<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="copyright-information">
<div style="padding-top:180px">
<p><strong>Other novels by Colin Cossor:</strong></p><br/>
<p><em>On Wings of Song</em></p>
<p><em>Wild Justice</em></p>
<p><em>Either Side the River</em></p>
<p><em>Over the Hill</em></p>
<p><em>Struggle</em></p>
<p><em>All Their Pride</em></p>
<p><em>The Woman at Checkout Nine</em></p>
<p><em>Rita</em></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?20ec2d2a